import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CustomButton from '../custom-material/button/Button'
import CustomDialog from '../custom-material/dialog/Dialog'
import { getImage, getSample } from '../../libs/help'
import { getBlob } from '../../libs/api'
import { saveAs } from 'file-saver'

const styles = theme => ({
  dialogPaper: {
    width: 1170,
    maxWidth: 1170
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 20
  },
  helpImage: {
    width: '100%',
    height: '100%'
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingTop: 20,
    borderTop: '1px solid #E5E5E5'
  },
  downloadButton: {
    width: 200,
    height: 45,
    fontSize: 16,
    fontWeight: 600
  },
  demoButton: {
    width: 150,
    marginLeft: 5,
    height: 45,
    fontSize: 16,
    fontWeight: 600
  },
  okButton: {
    width: 150,
    marginLeft: 5,
    height: 45,
    fontSize: 16,
    fontWeight: 600
  }
})

const downloadSample = id => async () => {
  const sample = getSample(id)
  try {
    const fileBlob = await getBlob(`/learn-more-images/${sample.url}`)
    saveAs(fileBlob, sample.fileName)
  } catch (error) {
    console.error(error)
  }
}

const requestDemo = (publicationName, contact) => event => {
  const requestAddress = 'healthcare@ipdanalytics.com'
  const subject = `Interested in the ${publicationName}`
  const body = `I am interested in learning more about the ${publicationName}. Please contact me with more information.%0D%0A%0D%0AThanks!%0D%0A${contact.firstName || ''} ${contact.lastName || ''}%0D%0A${contact.company || ''}%0D%0A${contact.officePhone || ''}%0D%0A${contact.emailAddress || ''}`
  window.location.href = `mailto:${requestAddress || ''}?subject=${subject}&body=${body}`
}

const HelpDialog = ({
  classes,
  dialogOpen,
  handleCloseDialog,
  helpSelected,
  contact
}) => (
  <CustomDialog
    classes={{ paper: classes.dialogPaper }}
    open={dialogOpen}
    onClose={handleCloseDialog}
  >
    <div className={classes.contentContainer}>
      {/* Show custom content (if provided) or fallback to image */}
      {helpSelected && helpSelected.content ? (
        <div>{helpSelected.content}</div>
      ) : (
        <img
          className={classes.helpImage}
          src={`/learn-more-images/${decodeURI(getImage(helpSelected.id))}`}
          alt='Help'
        />
      )}

      <div className={classes.actionContainer}>
        {/* Only show Download/Demo when there is NO custom content */}
        {!(helpSelected && helpSelected.content) && (
          <>
            <CustomButton
              key='download'
              onClick={downloadSample(helpSelected.id)}
              className={classes.downloadButton}
              variant='contained'
              size='small'
              color='secondary'
            >
              Download a Sample
            </CustomButton>
            <CustomButton
              key='demo'
              onClick={requestDemo(helpSelected.name, contact)}
              className={classes.demoButton}
              variant='contained'
              size='small'
              color='secondary'
            >
              Set up a demo!
            </CustomButton>
          </>
        )}
        {/* Always keep the OK button */}
        <CustomButton
          onClick={handleCloseDialog}
          className={classes.okButton}
          variant='contained'
          size='small'
          color='secondary'
        >
          Ok, I got it!
        </CustomButton>
      </div>
    </div>
  </CustomDialog>
)

HelpDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogOpen: PropTypes.bool.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
  helpSelected: PropTypes.object,
  contact: PropTypes.object
}

export default withStyles(styles)(HelpDialog)
